import { Appeal, BenefitType } from '@scts/models';
import {
  getEnumKeyByEnumValue,
  standardDateFormatter,
  useTitleService,
} from '@scts/utilities';
import { useNavigate } from 'react-router-dom';
import { PageHeaderSg } from '@scts-ui/component-library';

interface AppealsProps {
  appeals: Appeal[];
}

export const AppealsComponent = (appealsProps: AppealsProps) => {
  useTitleService('List of Appeals: Social Security Chamber');
  const nav = useNavigate();

  //need an appeal ID to get the appeal data from state mgmnt
  const handleClick = (id: string) => {
    nav('/appeal/' + encodeURIComponent(id));
  };

  //handle return or space on list item (keyboard click)
  const handleKeyPress = (e: any, i: string) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleClick(i);
    }
  };

  return (
    <div className="appellant-appeals-wrapper">
      <PageHeaderSg headerText={'Appeals'} />
      <ul className="appeals-ul">
        {appealsProps.appeals.length > 0 &&
          appealsProps.appeals.map((appeal, index) => (
            <li onKeyDown={(e) => handleKeyPress(e, appeal.caseReference)}>
              <div className="card-body" key={index}>
                <div
                  tabIndex={0}
                  className="d-flex flex-row appeals-item "
                  onClick={() => handleClick(appeal.caseReference)}
                  style={{
                    color: appeal.status === 'Completed' ? '#666' : '#105B7D',
                  }}
                >
                  <div className="d-flex flex-column flex-fill">
                    <h2
                      className="appeals-item-type"
                      style={{
                        backgroundColor:
                          appeal.status === 'Completed' ? '#fff' : '#f7f7f7',
                      }}
                    >
                      {getEnumKeyByEnumValue(BenefitType, appeal.benefit)}

                      <div className="appeals-item-ref fw-light">
                        <span className="fw-bold">Case Ref: </span>{' '}
                        {appeal.caseReference}
                      </div>
                    </h2>
                    <div>
                      <div className="d-flex flex-row appeals-item-date-status ">
                        <div className="flex-fill border-end col-6">
                          <span className="fw-bold">Started: </span>{' '}
                          {standardDateFormatter(
                            new Date(appeal.appealReceived)
                          )}
                        </div>
                        <div className="flex-fill ps-3 col-6">
                          {' '}
                          <span className="fw-bold">Status: </span>{' '}
                          {appeal.status}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="appeals-item-icon border-start">
                    <i className="bi bi-caret-right-fill fs-1  ps-1 pe-1"></i>
                  </div>
                </div>
              </div>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default AppealsComponent;
